import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedPatient: null,
  loginPatient: null,
  isAudioRecording: false,
};

const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    setSelectedPatient: (state, action) => {
      state.selectedPatient = action.payload;
    },
    clearSelectedPatient: (state) => {
      state.selectedPatient = null;
    },
    setLoginPatient: (state, action) => {
      state.loginPatient = action.payload;
    },
    clearLoginPatient: (state) => {
      state.loginPatient = null;
    },
    setIsAudioRecording: (state, action) => {
      state.isAudioRecording = action.payload;
    },
  },
});

export const {
  setSelectedPatient,
  clearSelectedPatient,
  setLoginPatient,
  clearLoginPatient,
  setIsAudioRecording,
} = patientSlice.actions;
export default patientSlice.reducer;
